import React from 'react';

import SubmitBugPopup from '../Popups/SubmitBugPopup';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

class OverlayHelpButtons extends React.Component
{

  render()
  {

    const
      {
        stageRenderData,
      } = this.props;


    let playAreaOffsetX = ( ( window.innerWidth - stageRenderData.width ) / 2 );
    let playAreaOffsetY = stageRenderData.stageStyleTop;

    return (
      <div style={ {
        width: ( stageRenderData.scale * 40 ) + "px",
        height: ( stageRenderData.scale * 60 ) + "px",
        position: "absolute",
        left: ( playAreaOffsetX + 6 ) + "px",
        top: ( playAreaOffsetY + 6 ) + "px"
      } }>

        <Popup trigger=
          {
            <button style={ {
              all: "unset",
              display: "inline-block",
              cursor: "pointer"
            } } >
              <img alt="bug report button"
                src="./ui/bug-report-button.png"
              />
            </button>
          }
          modal
        >
          { close => (

            <SubmitBugPopup close={ close } submit={ ( bugText ) => { console.log( "Submit Bug - ", bugText ); } } />

          ) }
        </Popup>

      </div>
    );
  }
}

export default OverlayHelpButtons;
